import { Page } from "components/page/page.component";
import { View } from "components/view/view.component";
import { Text } from 'components/text/text.component'
import { FilterType } from "model/filter.model";
import { useEffect, useState } from "react";
import style from './dashboard.module.css'
import { Filters } from "components/filters/filters.component";
import { PieCard } from "components/pieCard/pieCard.component";
import { RoomReservationCard } from "components/roomReservationCard/roomReservationCard.component";
import { useGetRoomReservationAndOccupationDashboardDataApi } from "api/dashboard.api";
import { ListDashboardOccupationAndReservationDataDTO } from "model/dashboard/listDashboardReservationAndOccupationData.model";
import { getSantanderRoomColor } from "utils/color.util";

interface DashboardPageProps {
    companyId?: string
}

export function DashboardRoomOccupationPage({companyId}: DashboardPageProps){

    const [buildingIds, setBuildingIds] = useState<string[]>([]);
    const [areaIds, setAreaIds] = useState<string[]>([]);
    const [selectedRoomIds, setSelectedRoomIds] = useState<string[]>([]);
    const [occupationStatus, setOccupationStatus] = useState<'ocupado' | 'desocupado' | undefined>(undefined);
    const [minCapacity, setMinCapacity] = useState<number | undefined>(undefined);
    const [maxCapacity, setMaxCapacity] = useState<number | undefined>(undefined);
    const [equipaments, setEquipaments] = useState<{id?: string, name: string}[]>([]);

    const {data, loading, get} = useGetRoomReservationAndOccupationDashboardDataApi()

    useEffect(()=>{
        getData()
        const interval = setInterval(getData, 60000)
        return () => clearInterval(interval)
    // eslint-disable-next-line
    }, [buildingIds, areaIds, selectedRoomIds, companyId])

    function getData() {
        get({
            companyUsername: companyId ?? '',
            buildingIds,
            areaIds,
            roomIds: selectedRoomIds
        })
    }

    function handleFilterChange(filter: FilterType){
        if(filter.buildings && filter.buildings.length > 0){
            setBuildingIds(filter.buildings.map(b => b.id))
        } else {
            setBuildingIds([])
        }
        if(filter.areas && filter.areas.length > 0){
            setAreaIds(filter.areas.map(a => a.id))
        } else {
            setAreaIds([])
        }

        setSelectedRoomIds(filter.rooms?.map(r => r.id) || []);
        // _getRooms()
        setOccupationStatus(filter.occupationStatus);

        setMinCapacity(filter.minCapacity);
        setMaxCapacity(filter.maxCapacity);
        console.log(`capacidade mínima: ${filter.minCapacity}, capacidade máxima: ${filter.maxCapacity}`);
        setEquipaments(filter.equipaments || []);
    }

    // function getColor(reserved?: boolean, occupied?: boolean, startDate?: Date){
    //     if(reserved === undefined || occupied === undefined) return 'grey'
    //     if(reserved && occupied) return 'red'
    //     if(reserved && startDate && (differenceInMinutes(new Date(), startDate)) <= 15) return 'yellow'
    //     if(reserved) return 'blue'
    //     if(occupied) return 'red' // orange
    //     return 'green'
    // }

    function getRoomEquipaments(roomData: ListDashboardOccupationAndReservationDataDTO){
        const companyEquipaments = roomData.room.company_constants?.filter(_ => _.indicator_id === 'tipos-equipamento') || []
        const roomEquipaments = roomData.room.constants?.filter(_ => _.indicator_id === 'room-equipament') || []
        const result = roomEquipaments.map(re => {
            const equipament = companyEquipaments.find(ce => ce.id === re.value)
            return {
                id: equipament?.id,
                name: equipament?.value || ''
            }
        })
        return result
    }

    const _roomsByBuildingAndArea:{buildingId: string, areaId: string, roomsData: ListDashboardOccupationAndReservationDataDTO[]}[] = []
    data?.filter(_ => {
        if(occupationStatus === 'ocupado') return _.occupied === true
        if(occupationStatus === 'desocupado') return _.occupied === false
        return true
    })
    .filter(_ => {
        if(equipaments.length === 0) return true
        const roomEquipaments = getRoomEquipaments(_) || []
        return equipaments.every(equipament => roomEquipaments.some(re => re.id === equipament.id))
    })
    .filter(_ => {
        let result = true
        const capacity = _.room.constants?.find(_ => _.indicator_id === 'room-capacity')?.value
        if(minCapacity !== undefined) result = capacity ? Number(capacity) >= minCapacity : false
        if(result && maxCapacity !== undefined) result = capacity ? Number(capacity) <= maxCapacity : false
        return result
    })
    .forEach(roomData => {
        const buildingId = roomData.room.building?.id ?? 'unknown';
        const areaId = roomData.room.area?.id ?? 'unknown';
        const _roomByBuildingAndArea = _roomsByBuildingAndArea.find(_ => _.buildingId === buildingId && _.areaId === areaId)
        if(_roomByBuildingAndArea){
            _roomByBuildingAndArea.roomsData.push(roomData)
        } else {
            _roomsByBuildingAndArea.push({buildingId, areaId, roomsData: [roomData]})
        }
    })

    return <Page menu header title="Dashboard">
        <View className={style.PageContent}>
            <Filters
                // canExpand
                expanded={false}
                showBuildings
                onlyEnableBuildings
                showAreas
                onlyEnableAreas
                showRooms
                onlyEnableRooms
                showOccupationStatus
                showCapacity
                // showEquipaments
                roomIndicatorIds={['reserva-sala', 'room-occupation-status']}
                companyId={companyId}
                onChange={handleFilterChange}
            />
        {
            loading
            ?
            <View className={style.Indicators}>
                <PieCard loading/> 
                <PieCard loading/> 
                <PieCard loading/> 
                <PieCard loading/>
                <PieCard loading/>
                <PieCard loading/>
            </View>
            :
            !_roomsByBuildingAndArea || _roomsByBuildingAndArea.length <= 0 
            ?<View className={style.IndicatorsContent}>
                <Text>nenhuma sala encontrada</Text> 
            {/* <RoomReservationItem roomId={'teste'} roomName={'Sala'} />  */}
            </View>
            :<View className={style.IndicatorsContent}>
                {_roomsByBuildingAndArea.map(({buildingId, areaId, roomsData}) => (
                    <View key={`${buildingId}-${areaId}`} className={style.IndicatorByBuildingAndAreaContent}>
                        <Text className={style.IndicatorTitle} type='h3' style={{marginBottom:'1rem'}}>{`${roomsData[0].room.building?.name} - ${roomsData[0].room.area?.name}`}</Text>
                        <View className={style.RoomList}>
                            {roomsData.map(roomData => {
                                const capacity = roomData.room.constants?.find(_ => _.indicator_id === 'room-capacity')?.value
                                return <a href={`/santander/dashboard/sala-reuniao/${roomData.room.id}`} key={roomData.room.id} style={{ textDecoration: 'none' }}>
                                <RoomReservationCard
                                    color={getSantanderRoomColor(roomData?.reserved, roomData?.occupied, roomData?.reserveStartAt)}
                                    title={roomData.room.name}
                                    occupied={roomData?.occupied}
                                    capacity={capacity ? Number(capacity) : undefined}
                                    // reserved={roomData?.reserved}
                                    // reservedBy={roomData?.reservedBy}
                                    // reserveStartAt={roomData?.reserveStartAt}
                                    // reserveEndAt={roomData?.reserveEndAt}
                                    id={roomData.room.id}
                                    sn={roomData.room.constants?.find(_ => _.indicator_id === 'room-occupation-status-viridi-serial-number')?.value}
                                    hoverText={`Equipamentos: ${'\n'}${getRoomEquipaments(roomData).map(_ => ` - ${_.name}`).join(',\n') || `Nenhum equipamento cadastrado`}`}
                                />
                            </a>
                        })}
                        </View>
                    </View>
                ))}
            </View>
        }
        </View>
    </Page>
}